import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { CircularProgress, Typography } from '@material-ui/core'

import {
  Button,
  Checkbox,
  Modal,
} from 'ui/components'

import Restrictions from 'ui/components/plan/Restrictions'

import {
  getPlan,
} from 'services/apiMotorBgc'

import reportError from 'utils/errorReporter'

import styles from './styles'

export default ({ docType, planId }) => {
  const classes = styles()
  const readOnly = true

  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)

  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [plan, setPlan] = useState({})

  const fetchPlan = async () => {
    setLoading(true)

    let res = null
    try {
      res = await getPlan(
        apiKey,
        userId,
        docType,
        planId,
      )
    } catch (err) {
      reportError(err, 'Erro ao obter o plano')
      setLoading(false)
      return
    }

    setPlan(res.data)
    setLoading(false)
  }

  const handleToggleModal = () => {
    fetchPlan()
    setModalOpen(!modalOpen)
  }

  const handleClose = () => {
    setModalOpen(false)
  }

  const renderPlanId = () => {
    return (
      <Typography>
        <strong>Plan ID:</strong>
        {' '}
        <span>{plan.plan_id}</span>
      </Typography>
    )
  }

  const renderPlanName = () => {
    return (
      <Typography>
        <strong>Nome:</strong>
        {' '}
        <span>{plan.name}</span>
      </Typography>
    )
  }

  const renderPlanDescription = () => {
    return (
      <Typography>
        <strong>Descrição:</strong>
        {' '}
        <span>{plan.description}</span>
      </Typography>
    )
  }

  const renderCheckboxVisibleToOrganization = () => {
    return (
      <div>
        <Checkbox
          value={plan.visible_to_organization}
          label="Compartilhar plano com outros usuários da minha organização"
          disabled={readOnly}
        />
      </div>
    )
  }

  const renderRestrictions = () => {
    return (
      <Restrictions
        docType={docType}
        processPole={plan.process_pole}
        planServices={plan.services}
        readOnly={readOnly}
      />
    )
  }

  const renderContent = () => {
    if (loading) return <CircularProgress />
    if (_.isEmpty(plan)) return null

    return (
      <div className={classes.contentContainer}>
        {renderPlanId()}
        {renderPlanName()}
        {renderPlanDescription()}
        {renderCheckboxVisibleToOrganization()}
        {renderRestrictions()}
      </div>
    )
  }

  return (
    <div>
      <Button
        variant="outlined"
        size="small"
        onClick={handleToggleModal}
      >
        Ver
      </Button>

      <Modal
        title="Plano"
        open={modalOpen}
        onClose={handleClose}
      >
        {renderContent()}
      </Modal>
    </div>
  )
}
